<template>
    <customModal :containermd="true" @closeModal="closeModal">
        <template #title>
              Prediction Dashboard - {{ siteCode }}
        </template>

        <template #body>
            <div class="row">
                <div class="chart-wrapper" style="position: relative; height: 320px; width: 100%;">
                    <div
                        v-if="loading"
                        class="d-flex flex-column align-items-center justify-content-center"
                        style="position: absolute; inset: 0; background: rgba(255, 255, 255, 0.75); z-index: 2;"
                    >
                        <div class="spinner-border text-primary" role="status"></div>
                        <div class="mt-2 text-muted">Loading graph data...</div>
                    </div>
                    <canvas ref="trendLineChart"></canvas>
                </div>
            </div>
            <div v-if="!loading && !hasGraphData" class="text-center text-muted mt-2">
                No trend history available for this site.
            </div>
        </template>
    </customModal>
</template>

<script src="../CraManagement/VisitPredictionDashboardModal.js"></script>
